<template>
    <!-- <template>
            <h1>
                Generar Etiquetas Cliente
            </h1>
        </template> -->
    <v-col>
        <s-crud title="Generar Etiquetas Cliente" @save="save($event)" :config="config" add :filter="filter" edit remove
            ref="gridCustomerTemplate" @rowSelected="rowSelected($event)" @addEvent="onClearForm()"
            @clearForm="onClearForm()" searchInput>

            <!-- <template v-slot:filter>
                <v-container>
                    <v-row style="margin-left: 5px" justify="center">
                        <v-col lg="3">
                            <s-select-definition clearable :def="1230" label="Planta Procesadora"
                                v-model="filter.TypeProcessingPlant" />
                        </v-col>

                        <v-col lg="3">
                            <s-select-definition clearable :def="1181" label="Destino"
                                v-model="filter.TypeDestiny"></s-select-definition>
                        </v-col>

                        <v-col lg="3">
                            <s-select-definition clearable :def="1269" label="Línea Proceso"
                                v-model="filter.TypeLineProcess"></s-select-definition>
                        </v-col>

                    </v-row>
                </v-container>
            </template> -->

            <template scope="props">
                <v-container fluid class="pa-2">
                    <!-- Sección de Datos Generales de la Etiqueta -->
                    <!-- <div class="tailwind-card">
                        <div class="tailwind-section-title">
                            <v-icon color="primary" small class="mr-2">mdi-information-outline</v-icon>
                            Datos Generales de la Etiqueta
                        </div>
                        <div class="tailwind-divider"></div> -->

                    <v-row dense>
                        <v-col cols="12" md="3" lg="4">
                            <sselect-client-sap label="Cliente" v-model="props.item.CardCode"
                                :disabled="props.item.AllClients"></sselect-client-sap>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                            <s-select-definition :def="1181" label="Destino"
                                v-model="props.item.TypeDestiny"></s-select-definition>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                            <s-select-definition :def="1610" label="Linea de Negocio" v-model="props.item.TypeBsnLine"
                                clearable />
                        </v-col>
                    </v-row>
                    <!-- </div> -->

                    <v-col cols="12" class="d-flex align-end pa-0">
                        <v-checkbox v-model="props.item.AllClients" label="Aplicar para todos" dense hide-details
                            class="ma-0 pa-0" @change="onAllClientsChange($event, props.item)"></v-checkbox>
                    </v-col>

                    <!-- Switch to activate PTI Codes -->
                    <div class="tailwind-switch-container mt-2">
                        <v-switch v-model="props.item.AddPtiCodes" label="AGREGAR CODIGOS PTI" color="success" dense
                            hide-details class="ma-0 pa-0"></v-switch>
                    </div>

                    <!-- Conditional PTI Fields -->
                    <!-- <template v-if="props.item.AddPtiCodes">
                        <div class="tailwind-card">
                            <div class="tailwind-section-title">
                                <v-icon color="primary" small class="mr-2">mdi-barcode-scan</v-icon>
                                Configuración y Códigos PTI
                            </div>
                            <div class="tailwind-divider"></div>

                            <v-row dense>
                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select-definition label="Cultivo" :def="1173" v-model="props.item.TypeCrop"
                                        @change="onCultiveChange($event, props.item)"
                                        @getDataInitial="cropItems = $event">
                                    </s-select-definition>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select-variety full clearable :cultiveID="props.item.TypeCrop"
                                        v-model="props.item.VrtID" label="Variedad"
                                        @getDataInitial="varietyItems = $event">
                                    </s-select-variety>
                                </v-col>

                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select-definition label="Tipo Cultivo" clearable :def="1172"
                                        v-model="props.item.TypeCultive" @getDataInitial="cultiveItems = $event">
                                    </s-select-definition>
                                </v-col>

                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select class="text-capitalize" clearable autocomplete label="Marca Caja"
                                        :items="uniqueBrands(props.item.TypeCrop)" item-text="Text" item-value="Value"
                                        :value="props.item.Brand" @change="onChangeBrandName($event, props.item)"
                                        placeholder="Seleccionar marca" id="sBrandName" ref="sBrandName">
                                    </s-select>
                                </v-col>

                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select class="text-capitalize" clearable autocomplete label="peso caja (KG)"
                                        :items="itemsBoxWeights" item-text="Text" item-value="Value"
                                        :value="props.item.Weighed" @change="onChangeWeight($event, props.item)"
                                        placeholder="Seleccionar peso" id="sBoxWeight" ref="sBoxWeight">
                                    </s-select>
                                </v-col>

                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select-definition :def="1266" label="Calibre" v-model="props.item.TypeCaliber"
                                        clearable @getDataInitial="sizeItems = $event"></s-select-definition>
                                </v-col>

                                <div style="display: none;">
                                    <s-select-definition :def="1722"
                                        @getDataInitial="gtinItems = $event"></s-select-definition>
                                </div>

                                <v-col cols="12" sm="6" md="3" lg="3">
                                    <s-select autocomplete label="GTIN 14" :items="gtinItemsMapped"
                                        item-text="SelectionText" item-value="DedValue" :value="props.item.GtinID"
                                        @change="props.item.GtinID = $event" placeholder="Seleccionar GTIN 14"
                                        id="sGTIN14" ref="sGTIN14" clearable :slotTmp="true">
                                        <template v-slot:item="{ item }">
                                            <span v-html="item.DisplayText"></span>
                                        </template>
        </s-select>
</v-col>

<v-col cols="12" sm="4" md="3" lg="2" class="pt-5">
    <v-btn depressed block @click="addGtinCode(props.item)" class="tailwind-btn">
        AGREGAR CÓDIGO
    </v-btn>
</v-col>
</v-row>

<div class="tailwind-table-container">
    <v-data-table :headers="ptiHeaders" :items="getPtiTableItems(props.item.PtiCodesDetail)" hide-default-footer dense
        no-data-text="No hay códigos PTI agregados." class="elevation-0">
        <template v-slot:item.index="{ index }">
                                        {{ index + 1 }}
                                    </template>
        <template v-slot:item.Code="{ value }">
                                        <span class="font-weight-bold primary--text">{{ value }}</span>
                                    </template>
        <template v-slot:item.actions="{ index }">
                                        <v-btn icon color="error" small @click="removePtiCode(props.item, index)">
                                            <v-icon small>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
    </v-data-table>
</div>
</div>
</template> -->
                </v-container>
            </template>

            <template v-slot:CardCode="{ row }">
                <div class="w-full d-flex flex-column align-start justify-start gap-1">
                    <v-chip x-small color="primary" class="px-2 py-1 inline-block rounded-lg">
                        {{ row.CardCode }}
                    </v-chip>
                    <span style="font-size: 12px;" class="text-truncate d-block text-left" :title="row.CardName">
                        {{ row.CardName }}
                    </span>
                </div>
            </template>

            <template v-slot:Template="{ row }">
                <v-btn @click="openZebraEditor(row)" small color="light" dark
                    class="rounded-lg text-none font-weight-bold" depressed>
                    <v-icon small class="mr-1">mdi-file-document-edit</v-icon>
                    Plantilla General
                </v-btn>
            </template>

            <template v-slot:Variantes="{ row }">
                <v-btn @click="openVariantModal(row)" small color="blue" dark
                    class="rounded-lg text-none font-weight-bold" depressed>
                    <v-icon small class="mr-1">mdi-file-document-edit</v-icon>
                    Variantes
                </v-btn>
            </template>

            <template v-slot:ManagePTI="{ row }">
                <div class="d-flex align-center justify-center" style="gap: 8px;">
                    <v-btn @click="openPtiModal(row)" small color="primary"
                        class="rounded-lg text-none font-weight-bold" depressed>
                        <v-icon small class="mr-1">mdi-barcode</v-icon>
                        Códigos PTI
                    </v-btn>

                </div>
            </template>
        </s-crud>


        <v-dialog v-if="modalEditorZebra" v-model="modalEditorZebra" fullscreen persistent>
            <zebra-editor :label-data="zebraEditorPropData" :show-save="true" @close="modalEditorZebra = false"
                @save-template="onSaveTemplate"></zebra-editor>
        </v-dialog>

        <v-dialog v-if="modalPti" v-model="modalPti" max-width="1000" persistent>
            <prf-customer-template-pti :ctmp-id="selectedCtmpID" :customer-template="selectedCustomerTemplate"
                @close="modalPti = false"></prf-customer-template-pti>
        </v-dialog>

        <v-dialog v-if="modalVariant" v-model="modalVariant" max-width="1000" persistent>
            <prf-customer-template-variant :ctmp-id="selectedCtmpID" :customer-template="selectedCustomerTemplate"
                @close="modalVariant = false"></prf-customer-template-variant>
        </v-dialog>
    </v-col>
</template>

<script>
import _sPrfCustomerTemplateService from "@/services/FreshProduction/PrfCustomerTemplateService";
import SselectClientSap from '@/components/Sale/SselectClientSap.vue';
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety.vue";
import _sPackingService from "@/services/FreshProduction/PackingService";

import ZebraEditor from "../CustomerTemplate/ZebraEditor.vue";
import PrfCustomerTemplatePti from "./PrfCustomerTemplatePti.vue";
import PrfCustomerTemplateVariant from "./PrfCustomerTemplateVariant.vue";

export default {
    components: { SselectClientSap, SSelectVariety, ZebraEditor, PrfCustomerTemplatePti, PrfCustomerTemplateVariant },
    data: () => ({
        gtinItems: [],
        cultiveItems: [],
        varietyItems: [],
        cropItems: [],
        sizeItems: [],
        ptiHeaders: [
            { text: '#', value: 'index', sortable: false, width: '50px' },
            { text: 'Cultivo', value: 'TypeCropName', sortable: false },
            { text: 'Variedad', value: 'VrtName', sortable: false },
            { text: 'Tipo Cultivo', value: 'TypeCultiveName', sortable: false },
            { text: 'Caja', value: 'Brand', sortable: false },
            { text: 'Peso', value: 'WeighedName', sortable: false },
            { text: 'Calibre', value: 'TypeCaliberName', sortable: false },
            { text: 'GTIN 14', value: 'GtinName', sortable: false },
            { text: 'PLU', value: 'PluCode', sortable: false },
            { text: 'Acciones', value: 'actions', sortable: false, align: 'center', width: '100px' }
        ],
        SelectedBrandRow: [],
        itemsMaterialBrands: [],
        itemsBoxWeights: [],
        filter: {
            TypeDestiny: 0,
            TypeProcessingPlant: 0,
            TypeLineProcess: 0
        },
        config: {
            model: {
                CtmpID: "ID",
                CardCode: "string",
                TypeDestiny: "int",
                TypeBsnLine: "int",
                Template: "json",
                PtiCodesDetail: "array",
                Options: "Options",
                Variantes: "Variantes"
            },
            service: _sPrfCustomerTemplateService,
            headers: [
                { text: "ID", value: "CtmpID", width: 50 },
                { text: "Cliente", value: "CardCode" },
                { text: "Tipo Negociación", value: "TypeBsnLineName", width: 150, align: 'center' },
                { text: "Destino", value: "TypeDestinyName", width: 120, align: 'center' },
                { text: "Plantilla", value: "Template", width: 120, align: 'center', sortable: false },
                { text: "Variantes", value: "Variantes", width: 120, align: 'center', sortable: false },
                { text: "Códigos PTI", value: "ManagePTI", width: 120, align: 'center', sortable: false },
            ],
        },
        modalEditorZebra: false,
        modalPti: false,
        modalVariant: false,
        selectedCtmpID: null,
        selectedTemplateItem: null,
        selectedCustomerTemplate: null,
    }),
    computed: {
        gtinItemsMapped() {
            return (this.gtinItems || []).map(item => {
                return {
                    ...item,
                    SelectionText: item.DedHelper ? `${item.DedDescription} PLU: ${item.DedHelper}` : item.DedDescription,
                    DisplayText: item.DedHelper ? `${item.DedDescription} <b>PLU: ${item.DedHelper}</b>` : item.DedDescription
                };
            });
        },
        zebraEditorPropData() {
            if (!this.selectedTemplateItem) return null;
            return {
                Id: `General-${this.selectedTemplateItem.CtmpID}`,
                Template: this.selectedTemplateItem.Template
            };
        }
    },
    created() {
        this.Initialize();
    },
    methods: {
        uniqueBrands(TypeCrop) {
            if (!TypeCrop) return [];
            const list = [];
            const seen = new Set();
            (this.itemsMaterialBrands || []).forEach(x => {
                if (x.CropID == TypeCrop && x.Brand && !seen.has(x.Brand)) {
                    seen.add(x.Brand);
                    list.push({
                        Text: x.Brand,
                        Value: x.Brand
                    });
                }
            });
            return list;
        },
        getPtiTableItems(detail) {
            if (!detail) return [];
            const array = typeof detail === 'string' ? detail.split(',').filter(Boolean) : detail;
            if (!Array.isArray(array)) return [];
            return array.map(x => {
                if (x && typeof x === 'object') return x;
                return {
                    GtinName: x,
                    PluCode: '-',
                    TypeCropName: '-',
                    VrtName: '-',
                    TypeCultiveName: '-',
                    Brand: '-',
                    WeighedName: '-',
                    TypeCaliberName: '-'
                };
            });
        },
        onCultiveChange(cultiveID, item) {
            console.log("onCultiveChange:", cultiveID);
            item.Brand = null;
            item.Weighed = null;
            item.UnitMeasurement = null;
            item.TypeBox = null;
            item.VrtID = null;
            this.itemsBoxWeights = [];
            this.SelectedBrandRow = [];
        },
        Initialize() {
            this.loadMaterialBrands();
        },
        loadMaterialBrands() {
            const filter = {
                Search: '',
                TypeCrop: null,
                VrtID: null,
                TypeCultive: null,
                UwoStatus: 1 // @PackingLineStatus: ACTIVOS
            }
            _sPackingService.listMaterialBrand(filter, this.$fun.getUserID()).then(r => {
                this.itemsMaterialBrands = r.status == 200 ? r.data : [];
                // console.log("listMaterialBrand", r.data);
            }).catch(err => {
                console.error("Error al cargar marcas de material:", err);
            });
        },
        onChangeBrandName(brandName, item) {
            console.log("onChangeBrandName:", brandName);
            if (!brandName) {
                this.itemsBoxWeights = [];
                item.Brand = null;
                item.Weighed = null;
                item.UnitMeasurement = null;
                item.TypeBox = null;
                this.SelectedBrandRow = [];
                return;
            }
            item.Brand = brandName;

            const weights = [];
            const seen = new Set();
            const matchingItems = (this.itemsMaterialBrands || []).filter(x => x.Brand === brandName);

            matchingItems.forEach(x => {
                if (x.Weighed != null) {
                    const weightStr = String(x.Weighed);
                    if (!seen.has(weightStr)) {
                        seen.add(weightStr);
                        weights.push({
                            Text: x.Weighed + ' ' + x.UnitMeasurement,
                            Value: x.Weighed
                        });
                    }
                }
            });
            this.itemsBoxWeights = weights;
            item.TypeBox = matchingItems.map(x => x.TypeBox).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(', ');
            this.SelectedBrandRow = matchingItems;

            item.Weighed = null;
            item.UnitMeasurement = null;
        },
        onChangeWeight(weight, item) {
            console.log("onChangeWeight:", weight);
            if (weight == null) {
                item.Weighed = null;
                item.UnitMeasurement = null;
                this.SelectedBrandRow = (this.itemsMaterialBrands || []).filter(x => x.Brand === item.Brand);
                return;
            }
            item.Weighed = weight;
            const matchingItem = (this.itemsMaterialBrands || []).find(x => x.Brand === item.Brand && x.Weighed == weight);
            if (matchingItem) {
                item.UnitMeasurement = matchingItem.UnitMeasurement;
                item.TypeBox = matchingItem.TypeBox;
                this.SelectedBrandRow = [matchingItem];
            }
        },
        onChangeBrand(val, item) {
            console.log("onChangeBrand:", JSON.parse(JSON.stringify(val)));
            if (val && Array.isArray(val) && val.length > 0) {
                item.Brand = val.map(x => x.Brand).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(', ');
                item.TypeBox = val.map(x => x.TypeBox).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(', ');
                item.Weighed = val[0] ? val[0].Weighed : null;
                item.UnitMeasurement = val[0] ? val[0].UnitMeasurement : null;
                this.SelectedBrandRow = [...val];
            } else if (val && !Array.isArray(val)) {
                item.Brand = val.Brand;
                item.TypeBox = val.TypeBox;
                item.Weighed = val.Weighed;
                item.UnitMeasurement = val.UnitMeasurement;
                this.SelectedBrandRow = [val];
            } else {
                item.Brand = null;
                item.TypeBox = null;
                item.Weighed = null;
                item.UnitMeasurement = null;
                this.SelectedBrandRow = [];
            }
        },
        addGtinCode(item) {
            if (!item.Brand) {
                this.$fun.alert("Debe seleccionar una Marca Caja.", "warning");
                return;
            }
            if (!item.Weighed) {
                this.$fun.alert("Debe seleccionar un Peso Caja.", "warning");
                return;
            }
            if (!item.TypeCaliber) {
                this.$fun.alert("Debe seleccionar un Calibre.", "warning");
                return;
            }
            if (!item.GtinID) {
                this.$fun.alert("Debe seleccionar un GTIN 14 primero.", "warning");
                return;
            }
            if (!this.gtinItems || this.gtinItems.length === 0) {
                this.$fun.alert("No se cargaron los ítems de códigos PTI.", "warning");
                return;
            }
            const found = this.gtinItems.find(x => String(x.DedValue) === String(item.GtinID));
            if (!found) {
                this.$fun.alert("No se encontró el código GTIN 14 seleccionado.", "warning");
                return;
            }
            const code = found.DedAbbreviation || found.DedDescription;
            if (!code) {
                this.$fun.alert("El GTIN 14 seleccionado no tiene un código válido.", "warning");
                return;
            }

            if (!item.PtiCodesDetail || typeof item.PtiCodesDetail === 'string') {
                this.$set(item, 'PtiCodesDetail', []);
            }

            const exists = item.PtiCodesDetail.some(x => {
                if (x && typeof x === 'object') {
                    return String(x.TypeCaliber) === String(item.TypeCaliber) &&
                        String(x.Weighed) === String(item.Weighed) &&
                        String(x.Brand).toLowerCase() === String(item.Brand).toLowerCase();
                }
                return x === code.trim();
            });
            if (exists) {
                this.$fun.alert("Ya existe un código PTI registrado con la misma Marca, Peso Caja y Calibre.", "warning");
                return;
            }

            // Get descriptions for each selected value
            const cropDesc = (this.cropItems || []).find(x => x.DedValue == item.TypeCrop)?.DedDescription || '';
            const varietyDesc = (this.varietyItems || []).find(x => x.VrtID == item.VrtID)?.VrtDescription || '';
            const cultiveDesc = (this.cultiveItems || []).find(x => x.DedValue == item.TypeCultive)?.DedDescription || '';
            const brandDesc = item.Brand || '';
            const weightDesc = item.Weighed ? `${item.Weighed} ${item.UnitMeasurement || 'KG'}` : '';
            const sizeDesc = (this.sizeItems || []).find(x => x.DedValue == item.TypeCaliber)?.DedDescription || '';
            const gtinDesc = found.DedDescription || '';

            const ptiObject = {
                CtmpdID: 0,
                TypeCrop: item.TypeCrop,
                TypeCropName: cropDesc,
                VrtID: item.VrtID,
                VrtName: varietyDesc,
                TypeCultive: item.TypeCultive,
                TypeCultiveName: cultiveDesc,
                Brand: brandDesc,
                Weighed: item.Weighed,
                WeighedName: weightDesc,
                TypeCaliber: item.TypeCaliber,
                TypeCaliberName: sizeDesc,
                GtinID: item.GtinID,
                GtinName: gtinDesc,
                PluCode: found.DedHelper || '',
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID()
            };

            item.PtiCodesDetail.push(ptiObject);
        },
        removePtiCode(item, index) {
            if (item.PtiCodesDetail) {
                item.PtiCodesDetail.splice(index, 1);
            }
        },
        save(item) {
            console.log("item", item);

            // Validations for header
            if (!item.CardCode) {
                this.$fun.alert("Debe seleccionar un Cliente.", "warning");
                return;
            }
            if (!item.TypeDestiny) {
                this.$fun.alert("Debe seleccionar un Destino.", "warning");
                return;
            }
            if (!item.TypeBsnLine) {
                this.$fun.alert("Debe seleccionar una Línea de Negocio.", "warning");
                return;
            }

            // Validations for conditional PTI
            if (item.AddPtiCodes) {
                if (!item.PtiCodesDetail || item.PtiCodesDetail.length === 0) {
                    this.$fun.alert("Debe agregar al menos un código PTI en el detalle.", "warning");
                    return;
                }
            }

            if (!item.PtiCodesDetail || item.PtiCodesDetail.length === 0) {
                delete item.AddPtiCodes;
                delete item.PtiCodesDetail;
            } else {
                if (Array.isArray(item.PtiCodesDetail)) {
                    // item.PtiCodesDetail = item.PtiCodesDetail.map(x => ({ ...x, SecStatus: 1, UsrID: this.$fun.getUserID() }));
                    // item.PtiCodesDetail = item.PtiCodesDetail.map(x => (x && typeof x === 'object') ? x.Code : x);
                }
            }

            delete item.Brand;
            delete item.TypeBox;
            delete item.UnitMeasurement;
            delete item.GtinID;
            delete item.TypeCaliber;
            delete item.TypeCrop;
            delete item.TypeCultive;
            delete item.VrtID;
            delete item.Weighed;

            if (!item.Template) {
                item.Template = null;
            }
            item.SecStatus = 1;
            item.UsrCreateID = this.$fun.getUserID();

            console.log("Save")
            console.log(JSON.parse(JSON.stringify(item)));
            // return;

            if (typeof item.save === 'function') {
                item.save();
            } else {
                _sPrfCustomerTemplateService.save(item, this.$fun.getUserID()).then(() => {
                    this.modalEditorZebra = false;
                    this.$fun.alert("Plantilla guardada correctamente.", "success");
                    if (this.$refs.gridCustomerTemplate) {
                        this.$refs.gridCustomerTemplate.refresh();
                    }
                }).catch(err => {
                    console.error("Error al guardar plantilla:", err);
                    this.$fun.alert("Error al guardar la plantilla.", "error");
                });
            }
        },
        validationForm() {
            return true;
        },
        onClearForm() {
            // const defaultItem = {
            //     CtmpID: 0,
            //     CardCode: "*",
            //     TypeDestiny: 2,
            //     TypeBsnLine: 1,
            //     Template: "",
            //     PtiCodesDetail: [
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 1,
            //             TypeCaliberName: "CAL 06",
            //             GtinID: 1,
            //             GtinName: "07756002000397",
            //             PluCode: "3488",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 2,
            //             TypeCaliberName: "CAL 07",
            //             GtinID: 2,
            //             GtinName: "07756002000090",
            //             PluCode: "3488",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 3,
            //             TypeCaliberName: "CAL 08",
            //             GtinID: 3,
            //             GtinName: "07756002000106",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 4,
            //             TypeCaliberName: "CAL 09",
            //             GtinID: 4,
            //             GtinName: "07756002000113",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 5,
            //             TypeCaliberName: "CAL 10",
            //             GtinID: 5,
            //             GtinName: "07756002000120",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 6,
            //             TypeCaliberName: "CAL 12",
            //             GtinID: 6,
            //             GtinName: "07756002000137",
            //             PluCode: "4051",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 4,
            //             WeighedName: "4 kgm",
            //             TypeCaliber: 7,
            //             TypeCaliberName: "CAL 14",
            //             GtinID: 7,
            //             GtinName: "07756002000144",
            //             PluCode: "4051",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 10,
            //             WeighedName: "10 kgm",
            //             TypeCaliber: 3,
            //             TypeCaliberName: "CAL 08",
            //             GtinID: 3,
            //             GtinName: "07756002000106",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 11,
            //             WeighedName: "11 kgm",
            //             TypeCaliber: 3,
            //             TypeCaliberName: "CAL 08",
            //             GtinID: 3,
            //             GtinName: "07756002000106",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 10,
            //             WeighedName: "10 kgm",
            //             TypeCaliber: 4,
            //             TypeCaliberName: "CAL 09",
            //             GtinID: 4,
            //             GtinName: "07756002000113",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 11,
            //             WeighedName: "11 kgm",
            //             TypeCaliber: 4,
            //             TypeCaliberName: "CAL 09",
            //             GtinID: 4,
            //             GtinName: "07756002000113",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 10,
            //             WeighedName: "10 kgm",
            //             TypeCaliber: 5,
            //             TypeCaliberName: "CAL 10",
            //             GtinID: 5,
            //             GtinName: "07756002000120",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 11,
            //             WeighedName: "11 kgm",
            //             TypeCaliber: 5,
            //             TypeCaliberName: "CAL 10",
            //             GtinID: 5,
            //             GtinName: "07756002000120",
            //             PluCode: "4959",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 10,
            //             WeighedName: "10 kgm",
            //             TypeCaliber: 6,
            //             TypeCaliberName: "CAL 12",
            //             GtinID: 6,
            //             GtinName: "07756002000137",
            //             PluCode: "4051",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         },
            //         {
            //             CtmpdID: 0,
            //             TypeCrop: 1,
            //             TypeCropName: "MANGO",
            //             TypeCultive: null,
            //             TypeCultiveName: "",
            //             VrtID: null,
            //             VrtName: "",
            //             Brand: "sungold",
            //             Weighed: 11,
            //             WeighedName: "11 kgm",
            //             TypeCaliber: 6,
            //             TypeCaliberName: "CAL 12",
            //             GtinID: 6,
            //             GtinName: "07756002000137",
            //             PluCode: "4051",
            //             SecStatus: 1,
            //             UsrCreateID: String(this.$fun.getUserID())
            //         }
            //     ],
            //     AllClients: true,
            //     AddPtiCodes: true,
            // };

            // this.$nextTick(() => {
            //     if (this.$refs.gridCustomerTemplate && this.$refs.gridCustomerTemplate.row) {
            //         Object.keys(defaultItem).forEach(key => {
            //             this.$set(this.$refs.gridCustomerTemplate.row, key, defaultItem[key]);
            //         });
            //     }
            // });
        },
        onAllClientsChange(value, item) {
            if (value) {
                this.$set(item, 'CardCode', '*');
            } else {
                this.$set(item, 'CardCode', null);
            }
        },
        rowSelected(item) {
            console.log("rowSelected", JSON.parse(JSON.stringify(item)));
            const target = Array.isArray(item) ? item[0] : item;
            if (target) {
                // Automatically activate switch if target already has a Brand
                if (target.Brand) {
                    this.$set(target, 'AddPtiCodes', true);
                } else {
                    this.$set(target, 'AddPtiCodes', false);
                }

                // Check for AllClients
                if (target.CardCode === '*') {
                    this.$set(target, 'AllClients', true);
                } else {
                    this.$set(target, 'AllClients', false);
                }

                if (!target.PtiCodesDetail) {
                    this.$set(target, 'PtiCodesDetail', []);
                } else if (typeof target.PtiCodesDetail === 'string') {
                    this.$set(target, 'PtiCodesDetail', target.PtiCodesDetail.split(',').filter(x => x));
                }

                if (target.Brand) {
                    const brands = target.Brand.split(',').map(x => x.trim()).filter(Boolean);
                    const foundItems = this.itemsMaterialBrands.filter(b => brands.includes(b.Brand));
                    this.SelectedBrandRow = foundItems;

                    const weights = [];
                    const seen = new Set();
                    const brandName = brands[0];
                    (this.itemsMaterialBrands || []).forEach(x => {
                        if (x.Brand === brandName && x.Weighed != null) {
                            const weightStr = String(x.Weighed);
                            if (!seen.has(weightStr)) {
                                seen.add(weightStr);
                                weights.push({
                                    Text: x.Weighed,
                                    Value: x.Weighed
                                });
                            }
                        }
                    });
                    this.itemsBoxWeights = weights;
                } else {
                    this.SelectedBrandRow = [];
                    this.itemsBoxWeights = [];
                }
            }
        },
        openZebraEditor(item) {
            this.selectedTemplateItem = item;
            this.modalEditorZebra = true;
        },
        onSaveTemplate(jsonString) {
            if (this.selectedTemplateItem) {
                this.selectedTemplateItem.Template = jsonString;
                this.save(this.selectedTemplateItem);
            }
        },
        openPtiModal(row) {
            console.log("openPtiModal", row);
            this.selectedCtmpID = row.CtmpID;
            this.selectedCustomerTemplate = row;
            this.modalPti = true;
        },
        openVariantModal(row) {
            console.log("openVariantModal", row);
            this.selectedCtmpID = row.CtmpID;
            this.selectedCustomerTemplate = row;
            this.modalVariant = true;
        },
    },
};
</script>

<style scoped>
.tailwind-switch-container {
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
    margin-bottom: 0.5rem;
    display: inline-flex;
    align-items: center;
    transition: all 0.2s ease;
}

.tailwind-switch-container:hover {
    border-color: #d1d5db;
    background-color: #f3f4f6;
}

.tailwind-switch-container ::v-deep .v-input--switch .v-label {
    font-weight: 600;
    color: #374151 !important;
    font-size: 0.8125rem !important;
    letter-spacing: 0.03em;
}

.tailwind-card {
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.03);
    padding: 1rem;
    margin-bottom: 0.75rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.tailwind-card:hover {
    border-color: #d1d5db;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

.tailwind-section-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.tailwind-divider {
    border-top: 1px solid #f3f4f6;
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
}

.tailwind-table-container {
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    overflow: hidden;
    margin-top: 0.75rem;
}

.tailwind-table-header {
    background-color: #f9fafb !important;
}

.tailwind-table-header th {
    color: #374151 !important;
    font-weight: 600 !important;
    font-size: 0.75rem !important;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    border-bottom: 1px solid #e5e7eb !important;
}

.tailwind-table-row:hover {
    background-color: #f9fafb !important;
}

.tailwind-table-row td {
    border-bottom: 1px solid #f3f4f6 !important;
    font-size: 0.8125rem !important;
    color: #4b5563;
}

.tailwind-btn {
    background-color: #1976d2 !important;
    color: #ffffff !important;
    border-radius: 0.5rem !important;
    padding: 0.15rem 0.15rem !important;
    text-transform: none !important;
    font-weight: 600 !important;
    /* font-size: 0.275rem !important; */
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
    height: 32px !important;
    border: none !important;
}

.tailwind-btn:hover {
    background-color: #1565c0 !important;
}
</style>